import { COMMON_LOGIN_API_URL } from "../config";
import { translateClassifierToSpotlight } from "./translate-classifier-to-spotlight";

/** @typedef {{ base: { id: string, details: { classified: string, description: string }, identifier: { taxId: string, vatNumber: string, taxRegion: string } } }} Item */

/**
 * Generates a jump URL with context for a given item.
 * @param {Item} item The entire item object from the Redux store (state.item.item).
 * @param {string} tenantId WorkspaceId of the selected item.
 * @param {string} onefrontAppId Unique identifier of the application, provided by the onefront team.
 * @param {string} registryServiceId Identifier of the application in the centralized registry.
 * @param {any} [state={}] Extra state that should be available to the login flow.
 * @param {string} [deepLink="/"] Target URL to redirect to after login.
 * @param {Object} [deepLinkParameters={}]
 * @param {string} [label] Label that will be shown in the top bar of the application.
 */
export default function generateJumpUrlWithContext(
    item,
    tenantId,
    oneFrontAppId,
    registryServiceId,
    state = {},
    deepLink = "/",
    deepLinkParameters = {},
    label = "TeamSystem"
) {
    const tenantData = {
        id: tenantId,
        itemId: item.base.uuid,
        type: translateClassifierToSpotlight(item.base.details.classifier),
        description: item.base.details.description,
        identifiers: [
            { type: "TAX_ID", country: "IT", value: item.base.identifier.taxId },
            { type: "VAT_NUMBER", country: "IT", value: item.base.identifier.vatNumber }
        ],
        delegable: item.base.details.classifier === "STUDIO",
        countryCode: item.base.identifier.taxRegion
    };
    const ctxObject = {
        tenant: tenantData,
        // This should actually be the selected customer's workspace information
        // However, due to how portale works and the fact that none of the currently integrated OneFront
        // applications are connectable, tenant and workspace will always refer to the same item/workspace
        workspace: item.base.details.classifier === "STUDIO" ? tenantData : null,
        product: {
            id: oneFrontAppId,
            label
        }
    };

    deepLinkParameters["ctx"] = btoa(JSON.stringify(ctxObject));
    var deepLinkParameterArray = Object.entries(deepLinkParameters).map(
        ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    );
    const queryString = [
        `serviceId=${registryServiceId}`,
        `state=${btoa(JSON.stringify(state))}`,
        `deepLink=${deepLink}?${encodeURIComponent(deepLinkParameterArray.join("&"))}`
    ].join("&");

    return `${COMMON_LOGIN_API_URL}/jump?${queryString}`;
}
